import { all, fork, put, takeLatest } from "redux-saga/effects";
import { store } from "../../store";

import { SET_AUCTION } from "../../actions/controllers/auction";

import { requestAuction } from "../../actions/auctions";
import { loopUnderAuction } from "./loopUnderAuction";

export function* watchAuction() {
  yield takeLatest(SET_AUCTION, updateAuctionDependants);
}

export function* updateAuctionDependants(action) {
  let auction = action.data;
  let state = store.getState();
  let locale = state.locale.data;

  yield all([
    put(requestAuction(auction, locale)),
    fork(loopUnderAuction, auction, locale)
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/onSetAuction.js